import createTheme from '@mui/material/styles/createTheme';

const palette = {
    primaryText: '#27292B',
};

export default createTheme({
    palette: {
        text: {
            primary: palette.primaryText,
        },
        color: {
            primary: '#005D8F',
        }
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 768, // updating md only
            lg: 1200,
            xl: 1536,
        }
    },
    typography: {
        body1: {
            color: palette.primaryText,
            fontFamily: '"Open Sans", sans-serif',
            fontSize: '.875rem',
        },
    }
});